import {Component} from '@angular/core';

@Component({
  selector: 'app-inr-note-to-patient',
  templateUrl: './inr-note-to-patient.component.html',
  styleUrls: ['./inr-note-to-patient.component.scss']
})
export class InrNoteToPatientComponent {
  patientMsg!: string;

  postNote() {
    this.patientMsg = "";
  }
}
